import type { CmdbAenderung, DienstZustand } from './types'

/** Die Felder der Geschichte, wie sie in der Liste heißen. */
export const FELDER: Record<string, string> = {
  angelegt: 'Angelegt',
  geloescht: 'Gelöscht',
  name: 'Name',
  ip: 'IP-Adresse',
  art: 'Art',
  vorlage: 'Vorlage',
  hersteller: 'Hersteller',
  modell: 'Modell',
  firmware: 'Firmware',
  seriennummer: 'Seriennummer',
  standort: 'Standort',
  agent: 'Agent',
  uebergeordnet: 'Übergeordnetes Gerät',
  tags: 'Tags',
  aktiv: 'Überwachung aktiv',
  gekauft_am: 'Gekauft am',
  garantie_bis: 'Garantie bis',
  wartung_bis: 'Wartungsvertrag bis',
  abhaengigkeit: 'Abhängigkeit',
}

/** Eine Änderung als kurzer Satz: „7.2.8 → 7.2.10“, „neu: fw-01“. */
export function aenderungText(h: Pick<CmdbAenderung, 'feld' | 'alt' | 'neu'>): string {
  const wert = (v: string) => (v === 'true' ? 'ja' : v === 'false' ? 'nein' : v)
  if (h.feld === 'angelegt') return h.neu ? `angelegt (${h.neu})` : 'angelegt'
  if (h.feld === 'geloescht') return 'gelöscht'
  if (h.feld === 'abhaengigkeit') return h.neu ? `hängt jetzt an ${h.neu}` : `hängt nicht mehr an ${h.alt}`
  if (!h.alt) return `${FELDER[h.feld] ?? h.feld}: ${wert(h.neu)}`
  if (!h.neu) return `${FELDER[h.feld] ?? h.feld}: ${wert(h.alt)} entfernt`
  return `${FELDER[h.feld] ?? h.feld}: ${wert(h.alt)} → ${wert(h.neu)}`
}

export const ZUSTAND: Record<DienstZustand, { text: string; klasse: string }> = {
  ok: { text: 'in Betrieb', klasse: 'badge badge-ok' },
  eingeschraenkt: { text: 'eingeschränkt', klasse: 'badge badge-warn' },
  gestoert: { text: 'gestört', klasse: 'badge badge-crit' },
  unbekannt: { text: 'unbekannt', klasse: 'badge badge-off' },
}
